import { CART_KEY } from "./constants";

export const CART_UPDATED_EVENT = "kior-cart-updated";

export const getCart = () => {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY) || "[]");
  } catch {
    return [];
  }
};

export const getCartCount = () => getCart().length;

export const notifyCartUpdated = (detail = {}) => {
  window.dispatchEvent(
    new CustomEvent(CART_UPDATED_EVENT, {
      detail: { count: getCartCount(), ...detail },
    })
  );
};

export const addToCartItem = (item, options = {}) => {
  const cart = getCart();
  const exists = cart.some((c) => c._id === item._id);
  if (!exists) {
    const normalized = {
      _id: item._id,
      name: item.name,
      amount: Number(item.amount || item.price || 0),
      image: item.image || "",
      categoryId: item.categoryId || item.category || "",
      isPackage: Boolean(
        options.isPackage ||
          item.isPackage ||
          item.packageType ||
          Array.isArray(item.testIds)
      ),
    };
    cart.push(normalized);
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    notifyCartUpdated({ added: true, item: normalized });
    return { cart, added: true };
  }
  notifyCartUpdated({ added: false, item });
  return { cart, added: false };
};

/** Animate a flyer from source element to the header cart icon */
export const flyToCart = (fromEl) => {
  const cartEl = document.getElementById("header-cart-btn");
  if (!fromEl || !cartEl) return;

  const from = fromEl.getBoundingClientRect();
  const to = cartEl.getBoundingClientRect();
  const flyer = document.createElement("div");
  flyer.className = "cart-flyer";
  flyer.setAttribute("aria-hidden", "true");
  flyer.innerHTML =
    '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 2-2-.9-2-2-2zM7.16 14h9.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0 0 21.08 5H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7.16z"/></svg>';

  const startX = from.left + from.width / 2 - 14;
  const startY = from.top + from.height / 2 - 14;
  const endX = to.left + to.width / 2 - 14;
  const endY = to.top + to.height / 2 - 14;

  flyer.style.left = `${startX}px`;
  flyer.style.top = `${startY}px`;
  document.body.appendChild(flyer);

  requestAnimationFrame(() => {
    flyer.style.transform = `translate(${endX - startX}px, ${endY - startY}px) scale(0.35)`;
    flyer.style.opacity = "0.2";
  });

  setTimeout(() => {
    flyer.remove();
    cartEl.classList.remove("cart-bounce");
    // force reflow for restart animation
    void cartEl.offsetWidth;
    cartEl.classList.add("cart-bounce");
  }, 650);
};
